import React, { SVGProps } from 'react';

export const TrashIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M21 5.25h-3.559c-.901 0-.939-.114-1.186-.854l-.202-.607a2.247 2.247 0 0 0-2.134-1.539h-3.838c-.97 0-1.828.618-2.134 1.539l-.202.607c-.247.741-.285.854-1.186.854H3a.75.75 0 0 0 0 1.5h1.298l.767 11.499c.148 2.225 1.512 3.501 3.742 3.501h6.387c2.229 0 3.593-1.276 3.742-3.501l.767-11.499H21a.75.75 0 0 0 0-1.5ZM9.37 4.263a.75.75 0 0 1 .711-.513h3.838c.323 0 .609.206.711.513l.202.607c.044.131.088.258.136.38H9.03c.048-.123.093-.25.137-.38l.203-.607Zm8.068 13.886c-.095 1.433-.809 2.101-2.245 2.101H8.806c-1.436 0-2.149-.667-2.245-2.101L5.801 6.75h.757c.125 0 .229-.013.341-.021.034.005.065.021.1.021h10c.036 0 .066-.016.1-.021.112.008.216.021.341.021h.757l-.759 11.399ZM14.75 11v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 1.5 0Zm-4 0v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 1.5 0Z"
      />
    </svg>
  );
};
